import React, { useContext, useState } from 'react';

import { RestApiContext } from '../../contexts/RestApiContext';
import { useAggregatedState, useBusyState } from '../../../helpers';

export const PageContext = React.createContext(null);

const { Provider } = PageContext;
export const PageProvider = ({ ...props }) => {
    const [busy, isBusy, setIsBusy] = useBusyState({});
    const [pageIsReady, setPageIsReady] = useState(false);
    const [state, setState] = useAggregatedState({
        exportInfo: null,
        notAvailable: false,
    });

    const apiClient = useContext(RestApiContext);

    const getExportInfoAsync = async (token) => {
        try {
            const exportInfo = await apiClient.getDataExportInfoAsync(token);
            setState({
                exportInfo,
                notAvailable: false
            });
        } catch (e) {
            console.debug(e);
            setState({
                exportInfo: null,
                notAvailable: true
            });
        }
    }

    return (
        <Provider value={{
            state,
            pageIsReady,
            setPageIsReady,
            isBusy,
            setIsBusy,
            getExportInfoAsync
        }}>
            {props.children}
        </Provider>
    );
}